'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var classNames = require('classnames/bind');
var Divider_module = require('./Divider.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var cx = classNames__default["default"].bind(Divider_module["default"]);
var Divider = function (_a) {
    var _b;
    var width = _a.width, height = _a.height, children = _a.children, className = _a.className, childMargin = _a.childMargin, _c = _a.dashed, dashed = _c === void 0 ? false : _c, _d = _a.type, type = _d === void 0 ? 'horizontal' : _d, _e = _a.alignChildren, alignChildren = _e === void 0 ? 'center' : _e;
    var isVertical = type === 'vertical';
    var dividerWidth = width && !isVertical ? { width: width } : {};
    var dividerHeight = height && isVertical ? { height: height } : {};
    var margin = childMargin && !isVertical ? { marginLeft: childMargin, marginRight: childMargin } : {};
    var dividerClassNames = cx(Divider_module["default"].divider, className, (_b = {},
        _b["textAlign-".concat(alignChildren)] = !isVertical,
        _b.horizontal = !isVertical,
        _b.vertical = isVertical,
        _b.dashed = dashed,
        _b.solid = !dashed,
        _b));
    return (jsxRuntime.jsx("span", _tslib.__assign({ role: "presentation", style: _tslib.__assign(_tslib.__assign({}, dividerWidth), dividerHeight), className: dividerClassNames }, { children: children && jsxRuntime.jsx("span", _tslib.__assign({ style: margin }, { children: children })) })));
};

exports["default"] = Divider;
//# sourceMappingURL=Divider.js.map
